import { Col, Row, Text, TabControl } from 'components';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Header } from 'screens/Admin/components';
import {
  RewardPointsTab,
  ParticipationIndicatorTab,
  NotificationsTab,
  PollQuizConfigTab,
  P4PDayTab
} from './components';

// Sibling labels are still hardcoded English; only the P4P Day one is translated so far.
const TABS = ['Reward Points', 'Participation Indicator', 'Notifications', 'Poll & Quick Quiz'];
const TAB_KEYS = [
  'reward-points',
  'participation-indicator',
  'notifications',
  'poll-quiz',
  'p4p-day'
];

const GeneralSettings = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [...TABS, t('admin.p4pDay.tab')];
  const tabIdx = Math.max(0, TAB_KEYS.indexOf(searchParams.get('tab')));
  const setTab = (idx) => setSearchParams({ tab: TAB_KEYS[idx] });

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center between wid="100%">
          <Text h3>General Settings</Text>
        </Row>
      </Header>

      <Col start noFlex wid="100%" className="mt-[54px] h-[calc(100vh-54px)] overflow-y-auto">
        <TabControl options={tabs} selectedIdx={tabIdx} handleSelect={setTab} />

        {tabIdx === 0 && <RewardPointsTab />}
        {tabIdx === 1 && <ParticipationIndicatorTab />}
        {tabIdx === 2 && <NotificationsTab />}
        {tabIdx === 3 && <PollQuizConfigTab />}
        {tabIdx === 4 && <P4PDayTab />}
      </Col>
    </Col>
  );
};

export default GeneralSettings;
